import PropTypes from "prop-types";
import React from "react";

import { classNames } from "@swa-ui/string";

import styles from "./Grid.module.scss";

/**
 * Grid renders a grid using attributes passed in as props.
 */
export const Grid = (props) => {
  const {
    children,
    className,
    columnDefinitions,
    gutterSpacing = 0,
    horizontalPadding = 0,
    numberOfColumns = 12,
    role,
    rowSpacing = 0,
    style,
  } = props;

  return (
    <div className={getClass()} role={role} style={getStyle()}>
      {children}
    </div>
  );

  function getClass() {
    return classNames(className, styles.grid);
  }

  function getStyle() {
    return {
      ...style,
      "--grid-column-definitions": `repeat(${numberOfColumns}, 1fr)`,
      "--grid-gutter-spacing": `${gutterSpacing}px`,
      "--grid-horizontal-padding": `0 ${horizontalPadding}px`,
      "--grid-row-spacing": `${rowSpacing}px`,
      ...(columnDefinitions && { "--grid-column-definitions": columnDefinitions.join(" ") }),
    };
  }
};

Grid.displayName = "Grid";

Grid.propTypes = {
  /** The content that will be displayed when Grid is rendered. */
  children: PropTypes.node,

  /** Additional classes for positioning the component. */
  className: PropTypes.string,

  /**
   * Column width definitions to define each column's width. Not to be used with numberOfColumns.
   * This will look something like: ["20px", "30px", "40px", "40px", "30px", "20px"].
   */
  columnDefinitions: PropTypes.arrayOf(PropTypes.string),

  /** Spacing between each column. */
  gutterSpacing: PropTypes.number,

  /** Padding on left and right sides of the grid. */
  horizontalPadding: PropTypes.number,

  /** Number of grid columns. Not to be used with columnDefinitions. */
  numberOfColumns: PropTypes.number,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Spacing between each row. */
  rowSpacing: PropTypes.number,
};
